/**
 * 생기부 기록에 저장된 성취기준을 validate로 걸러 칩으로 복원한다.
 * refs가 없으면 keys를 2022로 간주한다.
 */

import { validateStandards } from '../../api/curriculumApi';
import {
  DEFAULT_CURRICULUM,
  recordCurriculum,
  toRecordSummary,
} from './achievementStandardPicker.utils';

export const droppedStandardsNotice = (count) => (
  count > 0 ? `성취기준 ${count}개는 현재 데이터에 없어 제외했습니다` : ''
);

const asKeyList = (value) => (
  Array.isArray(value) ? value.map((item) => String(item || '').trim()).filter(Boolean) : []
);

export const refsFromHistoryRecord = (record = {}) => {
  const rawRefs = record.achievement_standard_refs
    || record.achievementStandardRefs
    || [];
  if (Array.isArray(rawRefs) && rawRefs.length > 0) {
    return rawRefs
      .map((ref) => ({
        code: ref?.code || null,
        curriculum: recordCurriculum(ref),
        key: String(ref?.key || '').trim(),
        text: ref?.text || null,
      }))
      .filter((ref) => ref.key);
  }

  return asKeyList(record.achievement_standard_keys || record.achievementStandardKeys)
    .map((key) => ({
      curriculum: DEFAULT_CURRICULUM,
      key,
    }));
};

export const restoreValidatedStandards = async (input) => {
  const refs = Array.isArray(input) ? input : refsFromHistoryRecord(input);
  if (refs.length === 0) {
    return { droppedCount: 0, records: [] };
  }

  const result = await validateStandards({ refs });
  if (!result.ok) {
    return { droppedCount: 0, records: [] };
  }

  const records = (result.data?.valid || [])
    .filter((record) => record?.key)
    .map((record) => toRecordSummary(record));
  const droppedCount = Math.max(0, refs.length - records.length);
  return { droppedCount, records };
};
